import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  getTicketDetails: `${NAMESPACE}_GET_TICKET_DETAILS`,
  setTicketDetails: `${NAMESPACE}_SET_TICKET_DETAILS`,
  setLoading: `${NAMESPACE}_SET_TICKET_DETAILS_LOADING`,
  handlePersistComment: `${NAMESPACE}_HANDLE_PERSIST_COMMENT`,
  setCommentToState: `${NAMESPACE}_SET_COMMENT_TO_STATE`,
  updateACommentOnState: `${NAMESPACE}_UPDATE_A_COMMENT`,
  setProcessingComment: `${NAMESPACE}_SET_PROCESSING_COMMENT`,
  handleDeleteComment: `${NAMESPACE}_HANDLE_DELETE_COMMENT`,
  deleteCommentOnState: `${NAMESPACE}_DELETE_COMMENT_ON_STATE`,
  setLoadingChats: `${NAMESPACE}_SET_LOADING_CHATS`,
  setChatsToState: `${NAMESPACE}_SET_CHATS_TO_STATE`
};

export const actionCreators = {
  getTicketDetails: (payload) => ({ type: actions.getTicketDetails, payload }),
  handlePersistComment: (payload) => ({ type: actions.handlePersistComment, payload }),
  handleDeleteComment: (payload) => ({ type: actions.handleDeleteComment, payload })
};

export default {
  actions,
  actionCreators
};
